import type { IconProps } from './types';

function GridSmallIcon(props: IconProps) {
  const { size = 24, color = 'currentColor', ref, ...other } = props;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      {...other}
    >
      <path
        d="M19.5 16.5V19.5H16.5V16.5H19.5ZM13.5 16.5V19.5H10.5V16.5H13.5ZM7.5 16.5V19.5H4.5V16.5H7.5ZM19.5 10.5V13.5H16.5V10.5H19.5ZM13.5 10.5V13.5H10.5V10.5H13.5ZM7.5 10.5V13.5H4.5V10.5H7.5ZM19.5 4.5V7.5H16.5V4.5H19.5ZM13.5 4.5V7.5H10.5V4.5H13.5ZM7.5 4.5V7.5H4.5V4.5H7.5Z"
        stroke={color}
      />
    </svg>
  );
}

export { GridSmallIcon };
